















































import Vue from 'vue';
import GNB from '../components/common/GNB/GNB.vue';
import Spinner from '../components/common/Spinner/Spinner.vue';
import LabelsetDescription from '../components/Description/Description.vue';
import { axiosApiInstance } from '../utils/axiosInstances';
import Information from '../components/Information.vue';
import Pagination from '@/components/Pagination.vue';
import Button from '../components/common/Button/Button.vue';
import NotificationMessage from '../components/common/NotificationMessage/NotificationMessage.vue';
import { AnalysisStatusI } from '@/interfaces/AnalysisStatusI';
import { requestSchemaAnalysis } from '@/utils/axiosAgentInstance';
import AgentDownloadModal from '@/components/common/Modal/AgentDownloadModal.vue';

interface errorList {
  property: string;
  keyword: string;
  schema: string;
  givenData: string;
}
interface labelData {
  name: string;
  errorTypeList: string[];
  errorList: errorList[];
}

export default Vue.extend({
  components: {
    GNB,
    Spinner,
    LabelsetDescription,
    Information,
    Pagination,
    Button,
    NotificationMessage,
    AgentDownloadModal,
  },
  data(): {
    allErrorLabelDataList: labelData[];
    errorLabelDataList: labelData[];
    flag: boolean;
    componentFlag: boolean;
    buttonValue: string;
    loading: number;
    showErrorLabelList: boolean;
    noErrorLabelData: boolean;
    onAnalyzing: boolean;
    labelset: {
      name: string;
      description: string;
      analysisStatus: AnalysisStatusI;
      isModified: boolean;
    };
    pagination: {
      currentPage: number;
      maxPage: number;
      pageList: number[];
      firstPage: number;
      middlePage: number;
    };
  } {
    return {
      allErrorLabelDataList: [],
      errorLabelDataList: [],
      flag: true,
      componentFlag: false,
      buttonValue: '라벨데이터 재분석',
      loading: 0,
      showErrorLabelList: true,
      noErrorLabelData: false,
      onAnalyzing: false,
      labelset: {
        name: '',
        description: '',
        analysisStatus: { status: 'DONE' },
        isModified: false,
      },
      pagination: {
        currentPage: 1,
        maxPage: 0,
        pageList: [],
        firstPage: 1,
        middlePage: 0,
      },
    };
  },
  async created() {
    // labelset관련 정보를 보여주기 위한 값들 초기화
    this.getLabelset();
    this.loading = setInterval(() => this.getLabelset(), 10000);

    //Error가 있는 Label Data list를 보여주기 위한 값들로 초기화
    const result = await axiosApiInstance.get(
      `/api/v1/labelsets/${this.$route.params.labelsetId}/schema`,
    );
    const labelDataList = result.data.result.violation_per_item;
    for (const labelData in labelDataList) {
      const errorTypeList: string[] = [];
      const errorList: errorList[] = [];
      for (const error of labelDataList[labelData].violation_list) {
        let number = 0;
        if (error.keyword !== 'required') {
          number = errorTypeList.indexOf('구문오류');
          if (number === -1) errorTypeList.push('구문오류');
        } else {
          number = errorTypeList.indexOf('결측치');
          if (number === -1) errorTypeList.push('결측치');
        }

        const item = {
          property: error.property,
          keyword: error.keyword,
          schema: error.schema,
          givenData: error.given_data,
        };
        errorList.push(item);
      }
      this.allErrorLabelDataList.push({
        name: labelData,
        errorTypeList: errorTypeList,
        errorList: errorList,
      });
    }

    if (this.allErrorLabelDataList.length === 0) this.noErrorLabelData = true;

    //pagination을 위한 값들 초기화
    this.pagination.currentPage = 1;
    this.pagination.maxPage = Math.ceil(this.allErrorLabelDataList.length / 10);
    if (this.pagination.maxPage > 10) {
      for (let num = 1; num <= 10; num++) this.pagination.pageList.push(num);
    } else {
      for (let num = 1; num <= this.pagination.maxPage; num++)
        this.pagination.pageList.push(num);
    }
    this.pagination.middlePage =
      this.pagination.pageList[this.pagination.pageList.length / 2];

    this.changeDataList(1);
    this.componentFlag = true;
  },
  watch: {
    onAnalyzing: function (onAnalyzing) {
      if (!onAnalyzing) {
        window.location.reload();
      }
    },
  },
  methods: {
    async getLabelset() {
      const result = await axiosApiInstance.get(
        `/api/v1/labelsets/${this.$route.params.labelsetId}`,
      );
      const labelset = result.data.result;
      this.labelset.name = labelset.name;
      this.labelset.description = labelset.description;
      this.labelset.analysisStatus = labelset.analysis_status;
      this.labelset.isModified = labelset.is_modified;
      this.onAnalyzing = labelset.analysis_status.status === 'ANALYZING';

      if (this.onAnalyzing) this.showErrorLabelList = false;

      // 분석이 완료되면 분석된 error label data들의 list가 보여지도록 만들어 준다.
      if (!this.onAnalyzing) clearInterval(this.loading);
    },

    changeDataList(page: number) {
      this.errorLabelDataList = this.allErrorLabelDataList.slice(
        (page - 1) * 10,
        page * 10,
      );
      this.pagination.currentPage = page;
    },

    async onReanalysis() {
      // 수정된 label data가 한 개라도 존재한다면 활성화되는 재분석 요청 버튼을 누르게 되면 실행
      await requestSchemaAnalysis(this.$route.params.labelsetId);
      window.location.reload();
    },
  },
});
